import FSCss from "../../css/overview.module.css";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import NoteSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";

const FSTopBar = ({
  // setLoanUploadModal,
  ShowInDecimals,
  setShowInDecimals,
  history,
  softDeletedData,
  deleteItemsModel,
  setDeleteItemsModal,
  handleDelete,
  setHandleDelete,
  activeItem = null,
  handleDeletedGNNotesClick
}) => {
  return (
    <div className={FSCss.w100}>
      <div className={FSCss.uploadLoansMainContainer}></div>

      <div className={FSCss.listPageheader}>
        <div className={FSCss.headerLeftContainer}>
          {/* <div className={FSCss.heading}>Loan Listing</div> */}
          {/* <div className={FSCss.heading}  > */}

          {/* <div className={FSCss.iconContainer}>
                            <SearchIcon/>
                        </div> */}
          <div className={FSCss.iconContainer}>
            {/* <DeleteIcon/> */}
            {softDeletedData.length > 0 ? (
              <NoteSoftDelete
                softDeletedData={softDeletedData}
                deleteItemsModel={deleteItemsModel}
                setDeleteItemsModal={setDeleteItemsModal}
                handleDelete={handleDelete}
                setHandleDelete={setHandleDelete}
              />
            ) : (
              <RestoreSoftDelete />
            )}
          </div>

          {/* </div> */}
        </div>
        <div className={FSCss.headerRightContainer}>
          {/* <div className={FSCss.filterContainer}>
                        <FilterIcon />
                    </div> */}
          {/* <div className={FSCss.filterContainer}>
                        <span className="module-toggles">
                            <div className="toggle-item">
                                <div className="toggle-container">
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={ShowInDecimals}
                                            onChange={() => setShowInDecimals(!ShowInDecimals)}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </span>
                        <span className={FSCss.decimalLabel}>Show in Decimals</span>
                    </div> */}
          {/* <div className={FSCss.calenderContainer}>
                        <div className={FSCss.leftCalenderContainer}>
                            <div className={FSCss.calenderLabels}>
                                From
                            </div>
                            <div className={FSCss.calenderDate}>
                                01-01-2024
                            </div>
                            <div className={FSCss.calenderIconContainer}>
                                <CalenderIcon />
                            </div>
                        </div>

                        <div className={FSCss.RightCalenderContainer}>
                            <div className={FSCss.calenderLabels}>
                                To 
                            </div>
                            <div className={FSCss.calenderDate}>
                                01-03-2024
                            </div>
                            <div className={FSCss.calenderIconContainer}>
                                <CalenderIcon />
                            </div>
                        </div>
                    </div> */}
          {/* <div className={FSCss.TopbtnWrapper}>
                        <button
                            onClick={() => {setLoanUploadModal(true);}} 
                            type="button" 
                            className={FSCss.linkRegisterButton}> 
                            
                         
                            Link Registers
                        </button>
                    </div>
                    <div className={FSCss.TopbtnWrapper}>
                        <button
                            onClick={() => {setLoanUploadModal(true);}} 
                            type="button" 
                            className={FSCss.FinalseBtn}> 
                            
                            Finalise FS
                        </button>
                    </div> */}
          {activeItem === 2 && (
            <>
              <Button
                btnColor={buttoncss.secondary}
                label="Cashflow workings"
                onClick={() => {
                  history.push(`/financialstatement/cashflow/working`);
                }}
              />
              &ensp;
            </>
          )}
          {activeItem === 4 && (
            <Button
              btnColor={buttoncss.secondary}
              label="Deleted Tabs"
              onClick={() => {
               handleDeletedGNNotesClick()
              }}
            />
          )}
          &ensp;
          <Button
            btnColor={buttoncss.secondary}
            label="Link Registers"
            onClick={() => {
              history.push("/link-register");
              //   handleNew();
            }}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label="Finalise FS"
            //   onClick={handleFilter}
            onClick={() => {
              history.push("/finalize-fs");
              //   handleNew();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default FSTopBar;
